/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Progress_Extra_Rep_TitleInputs */

const en_us2_progress_extra_rep_title = /** @type {(inputs: Progress_Extra_Rep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rep ranges`)
};

const pt_br2_progress_extra_rep_title = /** @type {(inputs: Progress_Extra_Rep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faixas de repetições`)
};

const es_419_progress_extra_rep_title = /** @type {(inputs: Progress_Extra_Rep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rangos de repeticiones`)
};

const pt_pt2_progress_extra_rep_title = /** @type {(inputs: Progress_Extra_Rep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Intervalos de repetições`)
};

const fr_fr2_progress_extra_rep_title = /** @type {(inputs: Progress_Extra_Rep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plages de répétitions`)
};

const de_de2_progress_extra_rep_title = /** @type {(inputs: Progress_Extra_Rep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wiederholungsbereiche`)
};

const it_it2_progress_extra_rep_title = /** @type {(inputs: Progress_Extra_Rep_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fasce di ripetizioni`)
};

/**
* | output |
* | --- |
* | "Rep ranges" |
*
* @param {Progress_Extra_Rep_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const progress_extra_rep_title = /** @type {((inputs?: Progress_Extra_Rep_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Progress_Extra_Rep_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_progress_extra_rep_title(inputs)
	if (locale === "es-419") return es_419_progress_extra_rep_title(inputs)
	if (locale === "pt-PT") return pt_pt2_progress_extra_rep_title(inputs)
	if (locale === "fr-FR") return fr_fr2_progress_extra_rep_title(inputs)
	if (locale === "de-DE") return de_de2_progress_extra_rep_title(inputs)
	if (locale === "it-IT") return it_it2_progress_extra_rep_title(inputs)
	return en_us2_progress_extra_rep_title(inputs)
});
export { progress_extra_rep_title as "progress-extra.rep_title" }